/**
 * Asginaciones de preguntas a periodo y boleta
 */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types



export const OBTENER_PREGUNTAS_PERIODO_BOLETA_CONFIGURACION = "obtenerPreguntasPeriodoBoletaConfiguracion";
export const OBTENER_PREGUNTAS_PERIODO_BOLETA = "obtenerPreguntasPeriodoBoleta";
export const ASIGNAR_PREGUNTA_PERIODO_BOLETA = "asignarPreguntaPeriodoBoleta";
export const OBTENER_PREGUNTA_PERIODO_BOLETA = "obtenerPreguntaPeriodoBoleta";
export const ACTUALIZAR_PREGUNTA_PERIODO_BOLETA = "actualizarPreguntaPeriodoBoleta";


export const OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO = "obtenerPreguntasPorMunicipioPeriodo";

export const OBTENER_PREGUNTA_POR_MUNICIPIO_PERIODO = "obtenerPreguntaPorMunicipioPeriodo";

export const OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO_INSTITUCION_REVISORA = "obtenerPreguntasPorMuniPeriodoInsitucionRevisora";

export const OBTENER_DICCIONARIO_RESPUESTAS = "obtenerDiccionarioRespuestasPorPeriodo";

export const OBTENER_RESPUESTAS_MUNI_APROBADAS = "obtenerRespuestasMuniAprobadas";

export const OBTENER_RESPUESTAS_MUNI_APROBADAS_TEST = "obtenerRespuestasMuniAprobadasTest";
export const OBTENER_RESPUESTAS_MUNI_APROBADAS2 = "obtenerRespuestasMuniAprobadas2";


// mutation types
export const SET_PREGUNTAS_PERIODO_BOLETA = "setPreguntaPeriodoBoleta";
export const SET_PREGUNTA_PERIODO_BOLETA = "setPreguntaPeriodoBoleta";

const state = {
    preguntasPeriodoBoleta:[],
    preguntaPeriodoBoleta:[],    
}

const getters = {
    obtenerPreguntasPeriodoBoletas(state) {
      return state.boletas;
    },
}

const actions = {

   
    
    /**
     * Obtener las preguntas asignadas a periodo y boleta para la configuracion de boleta y preguntas
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    
     async [OBTENER_PREGUNTAS_PERIODO_BOLETA_CONFIGURACION](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/Configuracion/${datos.boletaId}/${datos.periodoId}`;
        /*if(datos.estadoId>0){
            endpoint = `api/BoletaMuni/Estado/${estadoId}`
        }*/
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     * Obtener las preguntas asignadas a periodo y boleta para el recolector
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
    async [OBTENER_PREGUNTAS_PERIODO_BOLETA](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/${datos.boletaId}/${datos.periodoId}`;
        if(datos.estadoId>0){
            endpoint = `api/BoletaMuni/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     * Asignar la pregunta al periodo y boleta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [ASIGNAR_PREGUNTA_PERIODO_BOLETA](context, datos){

        let endpoint=`api/PreguntasPeriodoBoleta`;

        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    /** PENDIENTE 2DSFADS FSADF DSF SDF SDF DS FDS FSD 
     * Obtener un registro especifico de preguntas periodo boleta
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    
    async [OBTENER_PREGUNTA_PERIODO_BOLETA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/PreguntasPeriodoBoleta/`)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    /** 
     * Actualizar un registro de pregunta periodo boleta
     * @param {*} context 
     * @param {*} datos S
     * @returns 
     */

    async [ACTUALIZAR_PREGUNTA_PERIODO_BOLETA](context, datos){
        console.log("Aqui tambien");        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/PreguntasPeriodoBoleta/`, datos)
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })

                

                .catch((error) => {
                    console.log(error)
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
                console.log(datos);
        });    
    },

    /**
     * Obtener las preguntas de un municipio y periodo para los aprobadores y revisores
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/AprobadorRevisor/${datos.periodoId}/${datos.municipioId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },


    /**
     * Obtener la estructura de una pregunta con sus respuestas por municipio, periodo y pregunta id
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_PREGUNTA_POR_MUNICIPIO_PERIODO](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/preguntas/${datos.boletaMuniId}/${datos.preguntaId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },


    /**
     * Obtener las preguntas de un municipio, periodo (BoletaMuniId) e institucion revisora para los aprobadores y revisores.
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO_INSTITUCION_REVISORA](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/AprobadorRevisor/Institucion/${datos.boletaMuniId}/${datos.institucionId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTA_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },






    /**
     *Obtener diccionario de respuestas y preguntas para exportación
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_DICCIONARIO_RESPUESTAS](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/DiccionarioRespuestas/Boleta/${datos.periodoId}/${datos.boletaId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },


    /**
     *Obtener las respuestas corregidas por el aprobador por periodo y boleta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_RESPUESTAS_MUNI_APROBADAS](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/Respuestas/Municipios/${datos.periodoId}/${datos.boletaId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     *Obtener las respuestas corregidas por el aprobador por periodo y boleta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_RESPUESTAS_MUNI_APROBADAS_TEST](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/Respuestas/Municipios/Test/${datos.periodoId}/${datos.boletaId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     *Obtener las respuestas aprobadas por el aprobador por periodo y boleta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_RESPUESTAS_MUNI_APROBADAS2](context, datos) {
        let endpoint = `/api/PreguntasPeriodoBoleta/RespuestasAprobadas/Municipios/${datos.periodoId}/${datos.boletaId}`;
        
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_PREGUNTAS_PERIODO_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },



    


    



    
}

const mutations = {
    [SET_PREGUNTAS_PERIODO_BOLETA](state, data) {
        state.boletas = data;
    },

    [SET_PREGUNTA_PERIODO_BOLETA](state, data) {
        state.boleta = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}